import { SET_MISCELLANEOUS } from '../constants/index';
import makeReducer from '../../utils/fabrickReducer';

export const initialState = {
  notification: null
}

export default makeReducer(initialState, SET_MISCELLANEOUS);